import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      whatsons: {},
      whatsonPdfs: {},
    },
    mutations: {
      SET_WHATSONS(state, { data, locale }) {
        state.whatsons = {
          ...state.whatsons,
          [locale]: {
            data,
            __updatedAt: Date.now(),
          }
        }
      },
      SET_WHATSON_PDFS(state, { data, locale }) {
        state.whatsonPdfs = {
          ...state.whatsonPdfs,
          [locale]: {
            data,
            __updatedAt: Date.now(),
          }
        }
      },
    },
    actions: {
      FETCH_WHATSONS({ state, commit }, { m, locale }) {
        if (state.whatsons[locale] 
          && state.whatsons[locale].data
          && Date.now() - state.whatsons[locale].__updatedAt < cachetime
        ) {
          return ;
        }

        return axios.get('/api/enf/whatson', {
          params: {
            m,
          },
        })
          .then((res) => {
            const data = res.data;
            if (!data) {
              throw {
                response: {
                  status: 404
                }
              }
            }
            commit('SET_WHATSONS', { data, locale});
          }).catch(err => {
            console.log(err);
            throw err
          });
      },
      FETCH_WHATSON_PDFS({ state, commit }, { locale }) {
        if (state.whatsons[locale] 
          && state.whatsons[locale].data
          && Date.now() - state.whatsons[locale].__updatedAt < cachetime
        ) {
          return ;
        }

        return axios.get('/api/enf/whatson-pdf')
          .then((res) => {
            const data = res.data;
            if (!data) {
              throw {
                response: {
                  status: 404
                }
              }
            }
            commit('SET_WHATSON_PDFS', { data, locale});
          }).catch(err => {
            console.log(err);
            throw err
          });
      }
    },
    getters: {
      getWhatsons: (state) => (locale) => {
        return state.whatsons[locale] ? state.whatsons[locale].data || {} : {};
      },
      getWhatsonPdfs: (state) => (locale) => {
        return state.whatsonPdfs[locale] ? state.whatsonPdfs[locale].data || {} : {};
      },
    }
  }
};